import { render, staticRenderFns } from "./ReceptionPanels.vue?vue&type=template&id=cfac1116&"
import script from "./ReceptionPanels.vue?vue&type=script&lang=js&"
export * from "./ReceptionPanels.vue?vue&type=script&lang=js&"
import style0 from "./ReceptionPanels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports